var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"h-100 lh-1 vg-td-inner",class:_vm.cls,style:('width: '+_vm.width+'px')},[_c('span',{ref:"content"},[_vm._v(_vm._s(_vm.value))])])])}
var staticRenderFns = []

export { render, staticRenderFns }